// components/artifacts/SurveyVariablesCard.js - Survey 변수 분석 결과 카드 컴포넌트

import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBalanceScale } from "@fortawesome/free-solid-svg-icons";
import { Icon24 } from '../ui';

/**
 * Survey 변수 분석 결과 카드 컴포넌트
 * @param {object} props
 * @param {object} props.surveyData - 파싱된 Survey 데이터
 */
const SurveyVariablesCard = ({ surveyData }) => {
  const [isVariablesExpanded, setIsVariablesExpanded] = useState(false);

  if (!surveyData) return null;

  return (
    <div
      style={{
        background: "#f9fafb",
        border: "2px solid #e5e7eb",
        borderRadius: "12px",
        marginBottom: "32px",
        overflow: "hidden",
      }}
    >
      <div
        onClick={() => setIsVariablesExpanded(!isVariablesExpanded)}
        style={{
          padding: "20px",
          background: "white",
          borderBottom: isVariablesExpanded
            ? "2px solid #e5e7eb"
            : "none",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          transition: "all 0.2s ease",
        }}
      >
        <h2
          style={{
            fontSize: "20px",
            fontWeight: 600,
            margin: 0,
            color: "#1f2937",
          }}
        >
          변수 분석 결과
        </h2>
        <Icon24
          name={isVariablesExpanded ? "folding" : "floating"}
          style={{
            color: "#6b7280",
            transition: "transform 0.2s ease",
          }}
        />
      </div>

      {isVariablesExpanded && (
        <div style={{ padding: "20px" }}>
          {surveyData.target_groups &&
            surveyData.target_groups.length > 0 && (
              <div style={{ marginBottom: "24px" }}>
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: 600,
                    marginBottom: "12px",
                    color: "#374151",
                  }}
                >
                  🎯 타겟 그룹
                </h3>
                <ul
                  className="analysis-list"
                  style={{ listStyle: "none", padding: 0 }}
                >
                  {surveyData.target_groups.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        padding: "16px",
                        background: "#eff6ff",
                        borderRadius: "8px",
                        marginBottom: "12px",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      <strong
                        style={{
                          color: "#1e40af",
                          fontSize: "16px",
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                        {item.name} ({item.targetCount}명)
                      </strong>
                      <p
                        style={{
                          margin: 0,
                          color: "#6b7280",
                          fontSize: "14px",
                          lineHeight: 1.6,
                        }}
                      >
                        {item.description}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            )}

          {surveyData.key_variables &&
            surveyData.key_variables.length > 0 && (
              <div style={{ marginBottom: "24px" }}>
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: 600,
                    marginBottom: "12px",
                    color: "#374151",
                  }}
                >
                  핵심 선별 변수
                </h3>
                <ul
                  className="analysis-list"
                  style={{ listStyle: "none", padding: 0 }}
                >
                  {surveyData.key_variables.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        padding: "16px",
                        background: "white",
                        borderRadius: "8px",
                        marginBottom: "12px",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <strong
                        style={{
                          color: "#1f2937",
                          fontSize: "16px",
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                        {item.variable_name}
                      </strong>
                      <p
                        style={{
                          margin: 0,
                          color: "#6b7280",
                          fontSize: "14px",
                          lineHeight: 1.6,
                        }}
                      >
                        {item.description}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            )}

          {surveyData.balance_variables &&
            surveyData.balance_variables.length > 0 && (
              <div style={{ marginBottom: "0" }}>
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: 600,
                    marginBottom: "12px",
                    color: "#374151",
                  }}
                >
                  <FontAwesomeIcon icon={faBalanceScale} />{" "}
                  균형 배분 변수
                </h3>
                <ul
                  className="analysis-list"
                  style={{ listStyle: "none", padding: 0 }}
                >
                  {surveyData.balance_variables.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        padding: "16px",
                        background: "#fef3c7",
                        borderRadius: "8px",
                        marginBottom: "12px",
                        border: "1px solid #fde68a",
                      }}
                    >
                      <strong
                        style={{
                          color: "#92400e",
                          fontSize: "16px",
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                        {item.variable_name}
                      </strong>
                      <p
                        style={{
                          margin: 0,
                          color: "#6b7280",
                          fontSize: "14px",
                          lineHeight: 1.6,
                        }}
                      >
                        {item.description}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default SurveyVariablesCard;
